import { render, staticRenderFns } from "./DocumentParentsSelection.vue?vue&type=template&id=f15e22ac&scoped=true&"
import script from "./DocumentParentsSelection.vue?vue&type=script&lang=js&"
export * from "./DocumentParentsSelection.vue?vue&type=script&lang=js&"
import style0 from "./DocumentParentsSelection.vue?vue&type=style&index=0&id=f15e22ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f15e22ac",
  null
  
)

export default component.exports